import momentTimezone from 'moment-timezone';
import useStore from './use-store';

const browserTimezone = momentTimezone.tz.guess();

const useTimezone = () => {
    const {store} = useStore();
    const {server, session} = store;
    const attributesSesssion = session.attributes;
    const attributesServer = server.attributes;

    let serverTimezone;

    if (attributesServer) {
        serverTimezone = attributesServer?.hasOwnProperty('timezone') ? attributesServer?.timezone : browserTimezone;
    } else {
        serverTimezone = browserTimezone;
    }

    const timezone = attributesSesssion?.hasOwnProperty('timezone') ? attributesSesssion?.timezone : serverTimezone;

    return {timezone};
};

export default useTimezone;
